module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/maestro-33e980abcd994ecb71159c2df68f3fdb.svg";